<template>
  <div class="tracker max-w-full">
    <div v-if="habits.length > 0">
      <header class="mint-header flex justify-between sticky top-0">
        <habit-dropdown
          v-if="monthView"
          :habits="filteredHabits.length > 0 ? filteredHabits : habits"
        />
        <category-dropdown v-else :categories="categories" />

        <div class="flex items-center">
          <span class="mr-2">{{ monthView ? 'Month View' : 'Week View' }}</span>
          <t-toggle v-model="monthView" />
        </div>
      </header>

      <transition name="fade" mode="out-in">
        <tracker-month-view
          v-if="monthView"
          :habit="selectedHabit"
          :days="days"
        />
        <tracker-week-view v-else :habits="habits" :days="days" />
      </transition>
    </div>

    <div v-else class="h-screen flex flex-col justify-between">
      <header class="mint-header text-center flex justify-center">
        Tracker
      </header>
      <div class="text-gray-500 text-center">
        <p>"I've never been lonely... until today."</p>
        <p class="mt-1 text-xs">- Your Habit Tracker</p>
      </div>
      <div>
        <div class="flex ml-vw-1-3 items-center text-gray-500">
          <i class="material-icons font-18px transform translate-y-2"
            >call_received</i
          >
          <p class="ml-2">Create your first habit</p>
        </div>
        <div class="h-62px mt-4"></div>
      </div>
    </div>
  </div>
</template>
<script>
const CategoryDropdown = () => import('@/components/CategoryDropdown')
const HabitDropdown = () => import('@/components/HabitDropdown')
const TrackerWeekView = () => import('@/components/TrackerWeekView')
const TrackerMonthView = () => import('@/components/TrackerMonthView')
import days from '@/assets/common/Days'
import { habitsCollection, logsCollection } from '../firebase'
import habitModule from '@/store/modules/habit.module'
import logModule from '@/store/modules/log.module'
import categoryModule from '@/store/modules/category.module'
import trackerModule from '@/store/modules/tracker.module'
import moment from 'moment/src/moment'

export default {
  name: 'Tracker',

  components: {
    CategoryDropdown,
    HabitDropdown,
    TrackerWeekView,
    TrackerMonthView
  },

  data: () => ({
    days
  }),

  computed: {
    categories: categoryModule.categories,
    habits: habitModule.habits,
    filteredHabits: habitModule.filteredHabits,
    selectedHabit: habitModule.selectedHabit,
    init: habitModule.init,
    logs: logModule.logs,
    monthView: trackerModule.monthView
  },

  mounted() {
    const year = moment().year()
    const todayIsSunday = moment().day() === 0
    const momentWeek = moment().week()
    this.days.forEach(day => {
      let week
      if (day.id === 0 && !todayIsSunday) {
        week = momentWeek + 1
      } else if (day.id !== 0 && todayIsSunday) {
        week = momentWeek - 1
      } else {
        week = momentWeek
      }

      day.date = moment()
        .year(year)
        .week(week)
        .day(day.name)
        .format('MM/DD/YYYY')
      day.week = week
      day.year = year
    })
  }
}
</script>

<style lang="scss" scoped>
.mint-header {
  display: flex;
  align-items: center;
  .a-icon {
    outline: none;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 18px;
    }
  }
}
.h-62px {
  height: 62px;
}
.font-18px {
  font-size: 18px;
}
.ml-vw-1-3 {
  margin-left: calc((100vw / 3) / 2);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
